import { Link } from "react-router-dom";
import CopyTxtIconBtn from "../CopyTxtIconBtn";
import { TableCell, Tooltip } from "@mui/material";
import { useContext } from "react";
import { SearchContext } from "../../context/searchText";

type props = {
    value: string, 
    hasCopyOption?: boolean, 
    route?: string, 
    remBorder?: boolean, 
    align?: "right" | "center" | "left" | "inherit" | "justify"
}

export const ResponsiveCell = ({value, hasCopyOption = false, route, remBorder = false, align = "right"}: props) => {
    const {searchTerm} = useContext(SearchContext);
    const text = value.replaceAll(searchTerm, "##@##").split( "##@##").reduce(
        ((acc, txt, i) => {
            if(i){
                acc.push(<mark key={txt+"marked"+i}>{searchTerm}</mark>);
            }
            acc.push(txt);
            
            return acc;
        })
        ,[] as (JSX.Element | string)[]);

    
    return (
        <TableCell 
            align={align}
            sx={{
                border: remBorder? 0 : null,
                maxWidth: {xs: "50px", md: "300px"},
                overflow: {xs: "hidden"},
                textOverflow: {xs: "ellipsis"},
                whiteSpace: {xs: "nowrap"},
            }}
        >
            {hasCopyOption? <CopyTxtIconBtn value={value}/> : null}
            <Tooltip title={value}>
                {
                    route
                    ? <Link style={{color: "white"}} to={route}>{text.map((txt) => txt)}</Link>
                    : <span>{text.map((txt) => txt)}</span>
                }
            </Tooltip>
        </TableCell>
    ); 
}